<template>
  <section>
    <gs-header title="Cấu hình lương cho saller"
      :breadcrumbs="[
        {title: 'Quản lý saler', route: {name: 'saler'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all">
      <el-form :model="localConfig" :rules="rules" label-width="200px" label-position="top" ref="config-saler-salary" @submit.prevent.native="validateBeforeSubmit()">
        <el-row :gutter="30" class="remove-margin">
          <el-col :span="24">
            <el-row :gutter="20" class="remove-margin">
              <el-col :span="18">
                <el-form-item label="KPI" prop="config.kpi">
                  <el-row :gutter="20" class="margin-sm-bottom">
                    <el-col :span="3" class="text-center">&nbsp;</el-col>
                    <el-col :span="5" class="text-center">Số vận đơn</el-col>
                    <el-col :span="5" class="text-center">Số tiền / 1 đơn</el-col>
                    <el-col :span="5" class="text-center">Tiền thưởng</el-col>
                    <el-col :span="5" class="text-center">Thêm tháng tích lũy</el-col>
                    <el-col :span="1" class="text-center">&nbsp;</el-col>
                  </el-row>
                  <el-row class="margin-sm-bottom" :gutter="20" v-for="(kpi, index) in kpiConfig" :key="index">
                    <el-col :span="3">{{index === 0 ? 'KPI tối thiểu' : 'Vượt chỉ tiêu'}}</el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiConfig[index]['number']" placeholder="Số đơn" class="input-number-kpi">
                        <div slot="prepend"><span class="text-red">
                          <span v-if="parseInt(kpiConfig[index]['number']) !== -1">
                            {{index === 0 ? '0' : kpiConfig[index - 1]['number'] | number }} - {{ kpiConfig[index]['number'] | number }} đơn
                          </span>
                          <span v-else>
                            > {{kpiConfig[index - 1]['number']| number}} đơn
                          </span>
                        </span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiConfig[index]['money']" placeholder="Số tiền / 1 đơn">
                        <div slot="append"><span class="text-red">{{kpiConfig[index]['money'] | vnd}}</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiConfig[index]['bonus']" placeholder="Tiền thưởng">
                        <div slot="append"><span class="text-red">{{kpiConfig[index]['bonus'] | vnd}}</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="5">
                      <el-input v-model="kpiConfig[index]['month_plus']" placeholder="Thêm tháng tích lũy">
                        <div slot="append"><span class="text-red">{{kpiConfig[index]['month_plus']}} tháng</span></div>
                      </el-input>
                    </el-col>
                    <el-col :span="1">
                      <a @click.prevent="removeKpi(kpiConfig, index)" class="text-red cursor-pointer"><i class="fa fa-trash"></i></a>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" class="margin-sm-bottom">
                    <el-col :span="24" class="text-center">
                      <a @click.prevent="newKpi(kpiConfig)" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm mới</a>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>

              <el-col :span="6">
                <el-form-item label="Số tiền / 1 đơn tích lũy" prop="config.salary_accumulation">
                  <el-input v-model="localConfig.config.salary_accumulation" placeholder="Số tiền / 1 đơn tích lũy">
                    <div slot="append"><span class="text-red">{{localConfig.config.salary_accumulation | vnd}}</span></div>
                  </el-input>
                </el-form-item>

                <el-form-item label="Số tiền / 1 khách hàng mới" prop="config.salary_by_customer">
                  <el-input v-model="localConfig.config.salary_by_customer" placeholder="Số tiền / 1 khách hàng mới">
                    <div slot="append"><span class="text-red">{{localConfig.config.salary_by_customer | vnd}}</span></div>
                  </el-input>
                </el-form-item>

                <el-form-item label="Số tháng tích lũy đơn" prop="config.month_accumulation">
                  <el-input v-model="localConfig.config.month_accumulation" placeholder="Số tháng tích lũy đơn">
                    <div slot="append"><span class="text-red">{{localConfig.config.month_accumulation | number}} tháng</span></div>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="24">
            <button :disabled="submitting" class="ui blue basic small button" native-type="submit"><i class="fa fa-floppy-o"></i> Lưu lại</button>
            <button :disabled="submitting" type="button" class="ui red basic small button" @click="resetConfig"><i class="fa fa-refresh"></i> Đặt lại cấu hình mặc định</button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>

<script>
import { getConfigBySaler, changeConfigBySaler, resetSalerConfig } from 'src/api/saller'
import { head } from 'lodash'
export default {
  name: 'SallerConfig',
  data () {
    return {
      submitting: false,
      localConfig: {
        'config': {
          'kpi': {},
          'bonus': {},
          'month_plus': {},
          'salary_accumulation': 0,
          'salary_by_customer': 0,
          'month_accumulation': 0
        }
      },
      kpiConfig: [],
      rules: {}
    }
  },
  methods: {
    validateBeforeSubmit () {
      this.submitting = true
      this.$refs['config-saler-salary'].validate((valid) => {
        if (valid) {
          this.localConfig.config.kpi = {}
          this.localConfig.config.bonus = {}
          this.localConfig.config.month_plus = {}
          this.kpiConfig.forEach(value => {
            this.localConfig.config.kpi[value.number] = value.money
            this.localConfig.config.bonus[value.number] = value.bonus
            this.localConfig.config.month_plus[value.number] = value.month_plus
          })
          changeConfigBySaler(this.$route.params.id, this.localConfig).then(response => {
            switch (response.code) {
              case 200:
                this.$store.dispatch('showNotify', {
                  title: 'Lưu cấu hình thành công',
                  type: 'success'
                })
                this.submitting = false
                this.$router.push({name: 'saler'})
                break
              case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.submitting = false
                break
              default:
                this.$store.dispatch('showNotify', {
                  title: 'Lưu cấu hình thất bại',
                  body: 'Hệ thống gặp sự cố vui lòng thử lại sau',
                  type: 'danger'
                })
                this.submitting = false
            }
          })
        } else {
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          this.submitting = false
          return false
        }
      })
    },
    newKpi (kpi) {
      kpi.push({
        number: -1,
        money: 0
      })
    },
    removeKpi (kpi, index) {
      kpi.splice(index, 1)
    },
    getConfig () {
      getConfigBySaler(this.$route.params.id).then(response => {
        if (response.code === 200) {
          this.localConfig = response.data
          Object.keys(this.localConfig.config.kpi).forEach(key => {
            this.kpiConfig.push({
              number: key,
              money: this.localConfig.config.kpi[key],
              bonus: this.localConfig.config.bonus ? this.localConfig.config.bonus[key] : 0,
              month_plus: this.localConfig.config.month_plus ? this.localConfig.config.month_plus[key] : 0
            })
          })
        }
      })
    },
    resetConfig () {
      this.$confirm(`Bạn chắc chắn muốn đặt lại cấu hình mặc định cho saler này`, 'Đặt lại cấu hình mặc định', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        resetSalerConfig(this.$route.params.id).then(response => {
          switch (response.code) {
            case 200:
              this.$store.dispatch('showNotify', {
                title: 'Đặt lại cấu hình thành công',
                type: 'success'
              })
              this.$router.push({name: 'saler'})
              break
            case 422:
              let er = response.data.errors
              let message = head(er[Object.keys(er)[0]])
              this.$store.dispatch('showNotify', {
                title: 'Vui lòng kiểm tra thông tin cần nhập',
                body: message,
                type: 'warning'
              })
              this.submitting = false
              break
            default:
              this.$store.dispatch('showNotify', {
                title: 'Đặt lại cấu hình thất bại',
                body: 'Hệ thống gặp sự cố vui lòng thử lại sau',
                type: 'danger'
              })
              this.submitting = false
          }
        })
      }).catch(() => {

      })
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>

<style lang="css">
.input-number-kpi input{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// SalerConfigByUser.vue?11b1ad9a